export default __webpack_public_path__ + "static/media/mobile-abouth264.7bfe9cf7.mp4";